// @flow
import * as React from 'react';

import { Buttons, Content, ModalButton, ModalHrefButton, ModalLinkButton, overlayStyle, StyledModal } from './style';

import { FormattedMessage } from 'react-intl';
import messages from './intl';

import type { LocationShape } from 'react-router';

type Props = {
    buttonLinkText?: $npm$ReactIntl$MessageDescriptor,
    children?: React.Node,
    closeText?: string | $npm$ReactIntl$MessageDescriptor,
    contentLabel?: string,
    disableSaveButton?: boolean,
    isBig?: boolean,
    isOpen: boolean,
    linkText?: string | $npm$ReactIntl$MessageDescriptor,
    linkTo?: string | LocationShape,
    linkUrl?: string,
    noButtons?: boolean,
    noPadding?: boolean,
    onLinkClicked?: Function,
    onRequestClose?: Function,
    onSave?: Function,
    saveText?: string | $npm$ReactIntl$MessageDescriptor
};
export default ({
    buttonLinkText,
    children,
    closeText,
    contentLabel = '',
    disableSaveButton = false,
    isBig = false,
    isOpen,
    linkText,
    linkTo,
    linkUrl,
    noButtons,
    noPadding,
    onLinkClicked,
    onRequestClose,
    onSave,
    saveText,
    ...props
}: Props) => {
    return (
        <StyledModal
            {...props}
            contentLabel={contentLabel}
            isBig={isBig}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={{ overlay: overlayStyle }}
        >
            <Content
                data-qa="modal"
                hasButtons={onRequestClose || onSave || linkUrl}
                isBig={isBig}
                noPadding={noPadding}
            >
                {children}
            </Content>
            {(onRequestClose || onSave || linkUrl) && (
                    <Buttons>
                        {onRequestClose && (
                            <ModalButton alternate data-qa="modal-cancel" onClick={onRequestClose}>
                                {typeof closeText === 'string' ? (
                                    closeText
                                ) : closeText ? (
                                    <FormattedMessage {...closeText} />
                                ) : (
                                    <FormattedMessage {...messages.cancel} />
                                )}
                            </ModalButton>
                        )}
                        {onSave && (
                            <ModalButton data-qa="modal-save" disabled={disableSaveButton} onClick={onSave}>
                                {typeof saveText === 'string' ? (
                                    saveText
                                ) : saveText ? (
                                    <FormattedMessage {...saveText} />
                                ) : (
                                    <FormattedMessage {...messages.save} />
                                )}
                            </ModalButton>
                        )}
                        {linkUrl && (
                            <ModalHrefButton data-qa="modal-link" href={linkUrl} target="_blank">
                                {typeof linkText === 'string' ? (
                                    linkText
                                ) : linkText ? (
                                    <FormattedMessage {...linkText} />
                                ) : (
                                    <FormattedMessage {...messages.learnMore} />
                                )}
                            </ModalHrefButton>
                        )}
                        {linkTo &&
                            onLinkClicked &&
                            buttonLinkText && (
                                <ModalLinkButton onClick={onLinkClicked} to={linkTo}>
                                    <FormattedMessage {...buttonLinkText} />
                                </ModalLinkButton>
                            )}
                    </Buttons>
                )}
        </StyledModal>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/modal/index.js